import { render, staticRenderFns } from "./OTPVerify.vue?vue&type=template&id=564e4df7&"
import script from "./OTPVerify.vue?vue&type=script&lang=js&"
export * from "./OTPVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564e4df7')) {
      api.createRecord('564e4df7', component.options)
    } else {
      api.reload('564e4df7', component.options)
    }
    module.hot.accept("./OTPVerify.vue?vue&type=template&id=564e4df7&", function () {
      api.rerender('564e4df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/OTPVerify.vue"
export default component.exports